import { Directive, ElementRef, Output, EventEmitter, AfterViewInit, OnDestroy, Input } from '@angular/core';

@Directive({
  selector: '[appObserveVisibility]'
})
export class ObserveVisibilityDirective implements AfterViewInit, OnDestroy {
  @Input() rootElement: HTMLElement | null = null; // Accept the root element as an input
  @Output() visible = new EventEmitter<boolean>();
  private observer: IntersectionObserver;

  constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.visible.emit(true);
            //console.log('element is visible now');
          }
          else {
            this.visible.emit(false);
            //console.log('element is hidden now');
          }
        });
      },
      {
        root: this.rootElement,
        threshold: [0.0]
      }
    );

    this.observer.observe(this.element.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
